import Hero from "../components/Hero";
import BookCar from "../components/BookCar";
import PlanTrip from "../components/PlanTrip";
import PickCar from "../components/PickCar";
import Banner from "../components/Banner";
import ChooseUs from "../components/ChooseUs";
import Testimonials from "../components/Testimonials";
import Faq from "../components/Faq";
import Download from "../components/Download";
import Footer from "../components/Footer";
import SEO from "../utils/seo";

function Home() {
  return (
    <>
      <SEO
        title="MyDearCab - Top Cab Services in Pune"
        description="Book Pune to Mumbai cab at lowest fare. Clean cars, safe drivers, airport pickup & drop, 24/7 service. Sedan, SUV, Innova available. WhatsApp Booking: 8007722929."
        keywords="taxi service in pune,pune cab booking,pune airport cab service,pune airport pickup and drop,local taxi pune,online cab booking pune, pune to shirdi cab,pune to nashik cab,pune to aurangabad cab,pune to kolhapur cab,pune to goa cab,pune to mahabaleshwar cab,pune to mumbai taxi,pune to mumbai one way cab,pune to mumbai drop taxi,pune to mumbai car rental, pune to mumbai taxi lowest fare,pune to mumbai cab price,pune to mumbai cheap cab,pune to mumbai budget taxi,24 hours pune to mumbai cab,safe pune to mumbai cab for family,pune to mumbai airport drop cab,pune to mumbai sedan cab,pune to mumbai suv cab, pune airport to mumbai cab,hinjewadi to mumbai cab,swargate to mumbai cab,wakad to mumbai cab, pune to mumbai cab one way at affordable fare,pune to mumbai taxi service with driver,book pune to mumbai cab on whatsapp, pune to mumbai cab,pune to mumbai taxi,pune to mumbai one way cab,pune to mumbai one way taxi,pune to mumbai cab fare,pune to mumbai airport drop taxi,pune to mumbai online cab booking, Pune to Mumbai Cab | One Way Taxi | Lowest Fare | 24×7 Service, Near me cab service, Near me taxi service, Near me car rental services"
        canonicalUrl="https://www.mydearcab.com/home"
      />
      <Hero />
      <BookCar />
      <PlanTrip />
      <PickCar />
      <Banner />
      <ChooseUs />
      <Testimonials />
      <Faq />
      <Download />
      <Footer />
    </>
  );
}

export default Home;
